import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '@/components/layout/PageHeader';
import { EntitlementGate } from '@/components/gates';
import { QaQueuePanel } from '@/components/scout';

export const Route = createFileRoute('/scout/qa/$runId/')({
  component: QaQueuePage,
});

function QaQueuePage() {
  const { runId } = Route.useParams();
  return (
    <EntitlementGate module="scout">
      <div className="space-y-6">
        <PageHeader title="Human QA Gate" backTo={`/scout/runs/${runId}`} />
        <QaQueuePanel runId={runId} />
      </div>
    </EntitlementGate>
  );
}
